import { render, staticRenderFns } from "./ReplyTo.vue?vue&type=template&id=844810e6&"
import script from "./ReplyTo.vue?vue&type=script&lang=js&"
export * from "./ReplyTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports